export enum FeedExportFormEnum {
    EmailsForExport = 'emailsForExport',
    CompaniesSelectorUid = 'companiesSelectorUid',
}
